/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Country_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Select a country..." |
*
* @param {User_Country_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_country_placeholder = /** @type {((inputs?: User_Country_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Country_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez un pays...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un país...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Selecione um país...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona una nazione...")
	return /** @type {LocalizedString} */ ("Select a country...")
});